import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/*
 * Created on Wed Jul 18 2018
 */


import { jsonConversions, WorkflowCaseInfoConverter, LockInfoConverter, CodebookLookupSequence } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { Inject } from '@logio/typescript-ioc';
import logger from '../../logger';
/**
 * @author VBr
 */

export var WorkflowAdministrationLayer =
/*#__PURE__*/
function () {
  function WorkflowAdministrationLayer() {
    _classCallCheck(this, WorkflowAdministrationLayer);

    this.baseUri = CONSTANTS.API.ENDPOINTS.WORKFLOW_ADMINISTRATION;
  }

  _createClass(WorkflowAdministrationLayer, [{
    key: "getWorkflowCaseDefinitions",
    value: function getWorkflowCaseDefinitions() {
      var getWorkflowCaseDefinitionsPromise = api("".concat(CONSTANTS.API.ENDPOINTS.CODEBOOK_LOOKUP).concat(CodebookLookupSequence.WorkflowDefinition)).get({
        responseType: 'json'
      }).then(function (response) {
        return response.data.result || [];
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return getWorkflowCaseDefinitionsPromise;
    }
  }, {
    key: "getWorkflowCases",
    value: function getWorkflowCases(criteria) {
      var _this = this;

      var getWorkflowCasesPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.WORKFLOW_CASES)).post(criteria, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (workflowCaseInfo) {
          return _this.workflowCaseInfoConverter.toObject(workflowCaseInfo, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return getWorkflowCasesPromise;
    }
  }, {
    key: "terminateCases",
    value: function terminateCases(caseIds) {
      var _this2 = this;

      var terminateCasesPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.TERMINATE_CASES)).post({
        caseIds: caseIds.toArray()
      }, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (workflowCaseInfo) {
          return _this2.workflowCaseInfoConverter.toObject(workflowCaseInfo, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return terminateCasesPromise;
    }
  }, {
    key: "abandonCases",
    value: function abandonCases(caseIds) {
      var _this3 = this;

      var terminateCasesPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.ABANDON_CASES)).post({
        caseIds: caseIds.toArray()
      }, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (workflowCaseInfo) {
          return _this3.workflowCaseInfoConverter.toObject(workflowCaseInfo, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return terminateCasesPromise;
    }
  }, {
    key: "getLocks",
    value: function getLocks(criteria) {
      var _this4 = this;

      var getLocksPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.LOCKS)).post(criteria, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (lockInfo) {
          return _this4.lockInfoConverter.toObject(lockInfo, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return getLocksPromise;
    }
  }, {
    key: "unlock",
    value: function unlock(locksInfo) {
      var unlockPromise = api("".concat(this.baseUri).concat(CONSTANTS.API.ENDPOINTS.UNLOCK)).post({
        locksInfo: locksInfo
      }, {
        responseType: 'json'
      }).then(function (response) {
        return response.data.result || [];
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return unlockPromise;
    }
  }]);

  return WorkflowAdministrationLayer;
}();

__decorate([Inject, __metadata("design:type", WorkflowCaseInfoConverter)], WorkflowAdministrationLayer.prototype, "workflowCaseInfoConverter", void 0);

__decorate([Inject, __metadata("design:type", LockInfoConverter)], WorkflowAdministrationLayer.prototype, "lockInfoConverter", void 0);